<ejs-dialog #editProductAssetDialog [isModal]="true" [showCloseIcon]="true" [visible]="false" (close)="onCancel()"
  (open)="onOpen($event)">
  <ng-template #header>
    {{'i18n.domain.assets.product-assets.edit-asset.assign-asset' | translate}}
  </ng-template>

  <ng-template #content>
    <ejs-tab #tabObj Selecting="Select" id="element" class="mt-2" [animation]="animation" heightAdjustMode="fill" (selecting)="select($event)" (created)="tabGroupCreated()">
      <e-tabitems>
        <e-tabitem>
          <ng-template #headerText>
            {{'i18n.domain.assets.product-assets.edit-asset.general' | translate}}
          </ng-template>
          <ng-template #content>
            <app-asset-upload-editor #assetUploadEditorComponent [assetUploadEditorForm]="assetUploadEditorForm" [isBrandLogoMode]="true"></app-asset-upload-editor>
          </ng-template>
        </e-tabitem>
        <e-tabitem>
          <ng-template #headerText>
            {{'i18n.domain.assets.product-assets.edit-asset.edit-image' | translate}}
          </ng-template>
          <ng-template #content>
            <div class="row">
              <div class="col-12 mb-2">
                <button class="btn btn-primary me-2 btn-fixedw rounded right"
                        type="button"
                        (click)="toggleFullScreen()">
                  <span class="e-icon icon-maximize"></span>
                  {{ 'i18n.domain.assets.product-assets.edit-asset.toggle-full-screen' | translate }}
                </button>
              </div>
            </div>
            @if(showImageEditor){
              <div class="row">
                <div class="col-12">
                  <app-asset-image-editor #assetImageEditorComponent [fileData]="assetUploadEditorForm.controls.base64FileData.value" [fullScreen]="isFullScreen"></app-asset-image-editor>
                </div>
              </div>
            }
          </ng-template>
        </e-tabitem>
      </e-tabitems>
    </ejs-tab>
  </ng-template>

  <ng-template #footerTemplate>
    <ng-container>
      <button class="e-control e-btn e-lib e-flat"
              (click)="onCancel()">
        {{'i18n.shared.cancel' | translate}}
      </button>
      <button class="e-control e-btn e-lib e-primary e-flat"
              (click)="onSave()">
        @if(isLoading){
          <div class="spinner-border spinner-border-sm me-3" role="status"></div>
        }
        {{'i18n.shared.save' | translate}}
      </button>
    </ng-container>
  </ng-template>
</ejs-dialog>
